import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ASSESSMENT_MODE_LABEL, ASSESSMENT_TYPE_LABEL, AssessmentApplicationMode, PostItem } from '@app/core/models';
import { SHARED_MODULES } from '@app/shared';
import { Checker, notNull, safeDate } from '@app/shared/utils';
import { AppSelectors } from '@app/store';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { isPast } from 'date-fns';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-subtitle-exam',
  imports: [SHARED_MODULES],
  templateUrl: './subtitle-exam.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubtitleExamComponent {
  protected readonly isEmployee: Signal<boolean>;
  protected readonly item = input<PostItem>();
  protected readonly data: Signal<PostItem[]>;
  private readonly _store = inject(Store);
  private readonly _translateService = inject(TranslateService);

  constructor() {
    this.isEmployee = toSignal(this.selectEmployee(), { initialValue: false });
    this.data = computed(() => {
      const item = this.item();
      return [
        ASSESSMENT_TYPE_LABEL[item.metadata.type],
        ASSESSMENT_MODE_LABEL[item.metadata.mode],
        !!item.metadata.code ? `#${item.metadata.code?.toUpperCase()}` : null,
        item.metadata.management_type,
        `${item.metadata.questions_count} ${this._translateService.instant('gestor-avaliacoes.questoes')}`,
      ].filter((data) => !!data);
    });
  }

  protected canSubmit(item: PostItem): boolean {
    return item.metadata.mode !== AssessmentApplicationMode.Impressa;
  }

  protected isWarning(item: PostItem): string {
    const limit = safeDate(item.metadata.date_end);
    if (!this.isEmployee() && this.canSubmit(item) && !item.user_concludeds_count && isPast(limit)) {
      return 'text-red-500 font-semibold';
    }
    return 'text-title';
  }

  private selectEmployee(): Observable<boolean> {
    return this._store.select(AppSelectors.DefaultFunction).pipe(
      notNull(),
      map((functionId) => Checker.isEmployee(functionId)),
    );
  }
}
